export const getUIKey = (queryID) => `PREFETCH_NEXT_PAGE_${queryID}`;
